<template>
    <Teleport class="mobile-full-screen-modal" to="body">
        <!-- 全屏遮罩 -->
        <transition name="el-fade-in-linear">
            <div
                v-if="modalVisible"
                class="mobile-full-screen-modal__mask"
                @click="
                    () => {
                        modalVisible = false
                    }
                "
            ></div>
        </transition>
        <!-- 主内容 -->
        <transition name="scale-fade">
            <div v-if="modalVisible" class="mobile-full-screen-modal__content">
                <div
                    class="content-close"
                    @click="
                        () => {
                            modalVisible = false
                        }
                    "
                ></div>
                <div class="content-slot">
                    <slot name="content"></slot>
                </div>
            </div>
        </transition>
    </Teleport>
</template>

<script>
import Teleport from '@/components/Teleport.vue'

export default {
    name: 'MobileFullScreenModal',
    components: {
        Teleport,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:visible'],
    computed: {
        modalVisible: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val)
            },
        },
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.lockBodyScroll()
            } else {
                this.unlockBodyScroll()
            }
        },
    },
    beforeUnmount() {
        // 组件销毁时确保恢复滚动
        this.unlockBodyScroll()
    },
    methods: {
        lockBodyScroll() {
            // 保存当前滚动位置
            this.scrollY = window.scrollY
            // 隐藏滚动条并锁定位置
            document.body.style.position = 'fixed'
            document.body.style.top = `-${this.scrollY}px`
            document.body.style.width = '100%'
            document.body.style.overflow = 'hidden'
        },
        unlockBodyScroll() {
            // 恢复滚动
            document.body.style.position = ''
            document.body.style.top = ''
            document.body.style.width = ''
            document.body.style.overflow = ''
            // 恢复滚动位置
            if (this.scrollY !== undefined) {
                window.scrollTo(0, this.scrollY)
            }
        },
    },
}
</script>

<style lang="less" scoped>
.mobile-full-screen-modal {
    &__content {
        width: 6.8rem;
        padding: 0.67rem 0.32rem 0.42rem;
        background-color: #fff;
        border-radius: 0.12rem;
        position: fixed;
        top: 36%;
        left: calc(50% - 3.4rem);
        z-index: 101;

        .content-close {
            width: 0.25rem;
            height: 0.25rem;
            background: url(../../../../assets/mobile/modal-close.png) no-repeat center;
            background-size: 100%;
            position: absolute;
            top: 0.42rem;
            right: 0.32rem;
        }
    }

    &__mask {
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.2);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
    }
}
</style>
